import { render, staticRenderFns } from "./ReplaceCard.vue?vue&type=template&id=de5c3d2a&"
import script from "./ReplaceCard.vue?vue&type=script&lang=js&"
export * from "./ReplaceCard.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReplaceCard.vue"
export default component.exports